import {useQuery} from '@tanstack/react-query';
import {lkApi} from 'api';
import {useBoolean} from 'hooks/useBoolean';
import {useCurrentUser} from 'hooks/useCurrentUser';
import {useCallback} from 'react';

export function useCartAuthPanel() {
    const {currentUser, isLoading: currentUseIsLoading} = useCurrentUser();

    const {data: currentDiscountData, isLoading} = useQuery({
        queryKey: ['currentDiscount'],
        queryFn: lkApi.getCurrentDiscount,
        retry: false,
        enabled: Boolean(currentUser),
    });

    const {value: authModalIsVisible, toggle: toggleAuthModal} = useBoolean();

    const handleSignInSuccess = useCallback(() => {
        // queryClient.invalidateQueries({queryKey: ['currentUser']});
        // toggleAuthModal();
        window.location.reload();
    }, []);

    return {
        currentLevel: Number(currentDiscountData?.level || 1),
        isLoading: currentUseIsLoading || isLoading,
        authModalIsVisible,
        toggleAuthModal,
        handleSignInSuccess,
        currentUser,
    };
}
